// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CategoriesSettings.module.css */
.CategoriesSettings_container__JNh2Y {
    padding: 2rem;
    min-height: 100vh;
    background-color: #000000;
    color: #ffffff;
  }
  .CategoriesSettings_headerSection__qBTVz {
    width: 100%;
    background-color: #1F1D1D;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  .CategoriesSettings_headerContent__Lzgja {
    max-width: 1200px;
    margin: 0 auto;
    padding: 100px 2rem 0;
  }
  
  .CategoriesSettings_headerTop__ADkF1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 2rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .CategoriesSettings_backButton__j3\\+0h {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(255, 255, 255, 0.05);
    border: none;
    border-radius: 8px;
    color: #fff;
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'Manrope', sans-serif;
    width: fit-content;
  }
  
  .CategoriesSettings_backButton__j3\\+0h:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  .CategoriesSettings_title__vcGFU {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #ffffff;
  }
  
  .CategoriesSettings_grid__STe-3 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 2rem;
  }
  
  .CategoriesSettings_card__EjsHH {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 1.5rem;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    cursor: pointer;
  }
  
  .CategoriesSettings_card__EjsHH:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(255, 0, 0, 0.2);
  }
  
  .CategoriesSettings_iconWrapper__EEXec {
    background-color: rgba(255, 0, 0, 0.1);
    padding: 1rem;
    border-radius: 50%;
    margin-bottom: 1rem;
    color: #ff0000;
  }
  
  .CategoriesSettings_categoryTitle__0pDhT {
    font-size: 1.25rem;
    font-weight: 500;
    margin: 0.5rem 0;
    color: #ffffff;
  }
  
  .CategoriesSettings_categoryCount__2kX\\+3 {
    color: #ff0000;
    font-size: 0.875rem;
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    .CategoriesSettings_container__JNh2Y {
      padding: 1rem;
    }
    
    .CategoriesSettings_grid__STe-3 {
      grid-template-columns: 1fr;
    }
    
    .CategoriesSettings_title__vcGFU {
      font-size: 1.5rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/components/CategoriesSettings.module.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,iDAAiD;EACnD;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,qDAAqD;IACrD,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA;IACE,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":["/* CategoriesSettings.module.css */\n.container {\n    padding: 2rem;\n    min-height: 100vh;\n    background-color: #000000;\n    color: #ffffff;\n  }\n  .headerSection {\n    width: 100%;\n    background-color: #1F1D1D;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n  }\n  \n  .headerContent {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 100px 2rem 0;\n  }\n  \n  .headerTop {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .backButton {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: rgba(255, 255, 255, 0.05);\n    border: none;\n    border-radius: 8px;\n    color: #fff;\n    padding: 0.75rem 1.25rem;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-family: 'Manrope', sans-serif;\n    width: fit-content;\n  }\n  \n  .backButton:hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n  \n  .title {\n    font-size: 2rem;\n    font-weight: 600;\n    margin-bottom: 2rem;\n    color: #ffffff;\n  }\n  \n  .grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1.5rem;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding-top: 2rem;\n  }\n  \n  .card {\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 12px;\n    padding: 1.5rem;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    cursor: pointer;\n  }\n  \n  .card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 16px rgba(255, 0, 0, 0.2);\n  }\n  \n  .iconWrapper {\n    background-color: rgba(255, 0, 0, 0.1);\n    padding: 1rem;\n    border-radius: 50%;\n    margin-bottom: 1rem;\n    color: #ff0000;\n  }\n  \n  .categoryTitle {\n    font-size: 1.25rem;\n    font-weight: 500;\n    margin: 0.5rem 0;\n    color: #ffffff;\n  }\n  \n  .categoryCount {\n    color: #ff0000;\n    font-size: 0.875rem;\n    opacity: 0.8;\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 1rem;\n    }\n    \n    .grid {\n      grid-template-columns: 1fr;\n    }\n    \n    .title {\n      font-size: 1.5rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CategoriesSettings_container__JNh2Y`,
	"headerSection": `CategoriesSettings_headerSection__qBTVz`,
	"headerContent": `CategoriesSettings_headerContent__Lzgja`,
	"headerTop": `CategoriesSettings_headerTop__ADkF1`,
	"backButton": `CategoriesSettings_backButton__j3+0h`,
	"title": `CategoriesSettings_title__vcGFU`,
	"grid": `CategoriesSettings_grid__STe-3`,
	"card": `CategoriesSettings_card__EjsHH`,
	"iconWrapper": `CategoriesSettings_iconWrapper__EEXec`,
	"categoryTitle": `CategoriesSettings_categoryTitle__0pDhT`,
	"categoryCount": `CategoriesSettings_categoryCount__2kX+3`
};
export default ___CSS_LOADER_EXPORT___;
